import React from 'react';
import { Icon } from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Enterprise/index.css';

export default function ShowPassword({showPassword, onClick, size }) {
    return (
        <Icon 
            category={'enterprise'}
            name={!showPassword ? 'visibility' : 'hide'}
            size={size}
            color={'#BDBDBD'}
            onClick={onClick}
            style={{alignSelf: 'center', cursor: 'pointer'}}
        />
    )
}

ShowPassword.defaultProps = {
    size: 30    
}